import React from 'react';

const PurchaseOrdersPage = React.lazy(() => import('pages/purchaseOrders'));
const PoDetailsPage = React.lazy(() => import('pages/purchaseOrders/details'));
const PORevisionsPage = React.lazy(() => import('pages/purchaseOrders/revisions'));
const POUpdateePage = React.lazy(() => import('pages/purchaseOrders/update'));

const policies = [{ resource: 'purchaseOrders', action: 'view' }];

export const definitions = [
  {
    index: true,
    policies: policies,
    component: <PurchaseOrdersPage />
  },
  {
    path: 'details/:poID',
    policies: policies,
    component: <PoDetailsPage />
  },
  {
    path: 'revisions/:poID',
    policies: policies,
    component: <PORevisionsPage />
  },
  {
    path: 'update',
    policies: policies,
    component: <POUpdateePage />
  }
];
